import { render, staticRenderFns } from "./policyList.vue?vue&type=template&id=47308bd0&scoped=true"
import script from "./policyList.vue?vue&type=script&lang=js"
export * from "./policyList.vue?vue&type=script&lang=js"
import style0 from "./policyList.vue?vue&type=style&index=0&id=47308bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47308bd0",
  null
  
)

export default component.exports